import { useQuery } from 'react-query';

export type useGetOrganisationNamesType = {
  data: OrganisationNameType[];
  error: Error | null;
  isLoading: boolean;
};

export type OrganisationNameType = {
  value: number | undefined;
  text: string;
};

const useGetOrganisationNames = (
  query: string,
  debounce?: number,
): useGetOrganisationNamesType => {
  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

  const getOrganisations = async () => {
    await sleep(debounce || 250);
    const response = await fetch(`/api/autocomplete/organisations/?q=${query}`);
    if (response.ok) return response.json();
    throw new Error('Something went wrong');
  };

  const { isLoading, error, data } = useQuery<
    Array<OrganisationNameType>,
    Error
  >({
    enabled: query?.length >= 4,
    queryFn: getOrganisations,
    queryKey: [query, 'get-organisation-names'],
  });

  return {
    data: data ?? ([] as unknown as OrganisationNameType[]),
    error,
    isLoading,
  };
};

export default useGetOrganisationNames;
